/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Token names mapped to their values, used for contrast checking when generating custom themes
 *
 * @codegen <<SignedSource::023110f136ad929098f2d5a341b7ad7c>>
 * @codegenCommand yarn build tokens
 */
var tokenValues = {
  'color.text.brand': '#579DFF',
  'elevation.surface.overlay': '#282E33',
  'color.background.selected': '#1C2B41',
  'color.text.selected': '#579DFF',
  'color.border.brand': '#579DFF',
  'color.chart.brand': '#388BFF',
  'color.text.inverse': '#1D2125'
};
export default tokenValues;